<template>
  <div>
    <!-- <v-layout pa-4 style="background-color: #e1dede;height: 200px;" >
      <v-flex xs10 pa-4  text-left ><span class="RBold" style="font-size: 40px;color: #015385;">Welcome Admin</span></v-flex>
</v-layout> -->
    <!-- <v-layout justify-space-between px-6>
      <v-flex xs12 sm6 md3 pa-2 align-self-center v-for="(value, i) in CountList" :key="i" v-flex style="position: relative;top: -110px;">
        <v-card elevation="2" class="pa-4 bluegrad" data-aos="fade-up" 
     data-aos-duration="1200">
          <v-layout justify-center py-2 wrap>
            <v-flex xs12 py-1 class="font1">{{ value.name }} :</v-flex>
            <v-flex xs12 py-1 class="font2">{{ value.count }}</v-flex>
            <v-flex xs12 py-1 class="font1">({{ value.voters }} Voters)</v-flex>
            <v-flex xs12 sm10  py-1>
              <v-btn small  block color="white" @click="adddialog = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add {{ value.name }}
        </v-btn>
            </v-flex>
            <v-flex xs12 sm9  py-1 v-if="adddialog == true">
              <v-text-field
                        type="text"
                        label="Name"
                        v-model="newName"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
</v-flex>
<v-flex xs12 sm1  py-1 v-if="adddialog == true">
  <v-btn small dark block color="#005787" @click="add()" class="buttons1">
          <v-icon small>mdi-check</v-icon>
        </v-btn>
</v-flex>
            <v-flex xs12 sm10  py-1>
              <v-btn small dark block color="#197eb6" @click="adddialog2 = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add Users
        </v-btn>
            </v-flex>
          
          </v-layout>
        </v-card>
        </v-flex>
    </v-layout> -->
    <v-layout wrap px-2 pt-4>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/multiple-users-silhouette.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalVoters }}</span><br/>
              <span class="font5">Total Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList?gender='+'Male')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/man.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalMaleVoters }}</span><br/>
              <span class="font5">Male Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex> 
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList?gender='+'Female')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/girl.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalFemaleVoters }}</span><br/>
              <span class="font5">Female Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/BoothList')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/voting-booth.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalBooths }}</span><br/>
              <span class="font5">Total Booth</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addConstituency')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/building.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalAssemblyConstituencies }}</span><br/>
              <span class="font5">Total Constituencies</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList?id='+'1')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/group.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.voterAgebetween }}</span><br/>
              <span class="font5">Voters between 18-35 age</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList?id='+'2')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/addfriend.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.voterAgeAbove35 }}</span><br/>
              <span class="font5">Voters above 35 age</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/VotersList?id='+'3')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/old-man.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.ageelderCount }}</span><br/>
              <span class="font5">senior citizen Voters <br/>(60+ age)</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
</v-layout>
    <v-layout wrap >
      <!-- style="position: relative;top: -50px;" -->
      <v-flex xs12 sm6 pa-4>
        <chart3/>
</v-flex>
      <v-flex xs12 sm6 pa-4>
        <chart2/>
</v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
import chart2 from "./chart2";
import chart3 from "./chart3";
export default {
  components: {
    chart2,
    chart3,
  //   AccountMenu2,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
// GRAPH
      series: [70, 20, 10],
      chartOptions: {
        colors: ["#D61A3C", "#0E26B1", "#FFA500", "rgb(0, 77, 26)"],
        fill: {
          colors: ["#D61A3C", "#0E26B1", "#FFA500", "rgb(0, 77, 26)"],
        },
        chart: {
          width: 380,
          type: "pie",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
            },
            autoSelected: "zoom",
          },
        },
        labels: [
          "Voters in favour",
          " Voters not in favour",
          "Undecided voters",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
//
CountList:[
  { 
    name: "Constituencies",
    count: 2,
    voters: 750,
},
{ 
    name: "Panchayat",
    count: 3,
    voters: 562,
},
{ 
    name: "Ward",
    count: 5,
    voters: 235,
},
{ 
    name: "Booth",
    count: 10,
    voters: 110,
},
],
adddialog:false,
adddialog2:false,
newName:"",
DataList:[],
    };
  },
 
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
      this.appLoading = true;
      axios({
        url: "/candidate/dashboard/count",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.DataList = response.data.data;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    appLogout() {
      axios({
        method: "get",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status==true) {
            this.$store.commit("logoutUser", true);
            localStorage.removeItem("id");
            // store.commit("menu", response.data.menus);
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    },
};
</script>
<style scoped>
.bluegrad{
  background: rgb(24,36,68);
background: linear-gradient(36deg, rgba(24,36,68,1) 3%, rgba(0,85,135,1) 52%, rgba(0,99,161,1) 95%);
}
#example2 {
  border: 1px solid;
  padding: 10px;
  box-shadow: 5px 10px #888888;
}
</style>
